import script from "./ListUrssaf.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListUrssaf.vue?vue&type=script&lang=ts&setup=true"

import "./ListUrssaf.vue?vue&type=style&index=0&id=4fd8ae98&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd8ae98"]])

export default __exports__